import { BASE_URL_API } from '@constants/base';
import { get, post } from '@utils/ajax';

/**
 * Authentication Service
 * Handles all authentication related API calls
 */
const authService = (() => {
    // Check if user is logged in
    const checkLogin = async () => {
        try {
            const response = await get(`${BASE_URL_API}/auth/check_login_api.php`);
            return response;
        } catch (error) {
            return error;
        }
    };

    // Get email info for login
    const getEmailInfo = async (params = {}) => {
        try {
            const response = await get(
                `${BASE_URL_API}/auth/a_login_api.php`,
                {
                    method: 'get_email_info',
                    ...params
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    // Login user
    const login = async payload => {
        try {
            const response = await post(
                `${BASE_URL_API}/auth/a_login_api.php`,
                {
                    method: 'login',
                    ...payload
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    // Logout user
    const logout = async () => {
        try {
            const response = await get(
                `${BASE_URL_API}/auth/a_logout_api.php`,
                {},
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    // Send forgot password request
    const forgotPassword = async payload => {
        try {
            const response = await post(
                `${BASE_URL_API}/auth/reset_password_api.php`,
                {
                    method: 'forgot_password',
                    ...payload
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    // Reset password
    const resetPassword = async payload => {
        try {
            const response = await post(
                `${BASE_URL_API}/auth/reset_password_api.php`,
                {
                    method: 'reset_password',
                    ...payload
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    // Register password
    const registerPassword = async payload => {
        try {
            const response = await post(`${BASE_URL_API}/auth/register_password_api.php`, payload, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    const checkTokenExpired = async payload => {
        try {
            const response = await get(
                `${BASE_URL_API}/auth/check_token_expired_api.php`,
                {
                    method: 'check_token_expired',
                    ...payload
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    return {
        checkLogin,
        getEmailInfo,
        login,
        logout,
        forgotPassword,
        resetPassword,
        registerPassword,
        checkTokenExpired
    };
})();

export default authService;
